import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

export default function ProtectedRoute({ children, permissions = [] }) {
    const { me } = useOutletContext() || {};

    if (!me) return <Navigate to="/login" replace />;

    const userPerms = me.permissions?.map(p => p.name) || [];

    const hasAccess = permissions.length === 0 || permissions.some(p => userPerms.includes(p));
    if (!hasAccess) return <Navigate to="/" replace />;

    return children;
}
